import { render, staticRenderFns } from "./IndustryDetail.vue?vue&type=template&id=54e25df5&scoped=true"
import script from "./IndustryDetail.vue?vue&type=script&lang=js"
export * from "./IndustryDetail.vue?vue&type=script&lang=js"
import style0 from "./IndustryDetail.vue?vue&type=style&index=0&id=54e25df5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e25df5",
  null
  
)

export default component.exports